export enum FormStatus {
    VALID = 'VALID',
    INVALID = 'INVALID',
}
